import { render, staticRenderFns } from "./BijzondereElementen.vue?vue&type=template&id=0c8e9ce8"
import script from "./BijzondereElementen.vue?vue&type=script&lang=js"
export * from "./BijzondereElementen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports